import { twMerge } from "tailwind-merge";

import { Translation } from "@/data/lang";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

const getFrequencyMap = (t: Translation) => ({
  d: t.analysis.shared.dateTime.daily,
  m: t.analysis.shared.dateTime.monthly,
  q: t.analysis.shared.dateTime.quarterly,
  y: t.analysis.shared.dateTime.annual,
  w: t.analysis.shared.dateTime.weekly,
});

type Props = {
  lang: Lang;
  updatedAt?: string | null;
  frequency: "d" | "m" | "q" | "y" | "w";
  className?: string;
};

export const UpdatedText = ({
  lang,
  updatedAt,
  frequency,
  className,
}: Props) => {
  const { t } = getTranslations(lang);
  const map = getFrequencyMap(t);
  return (
    <p className={twMerge("self-end px-2 text-xs text-zinc-500", className)}>
      {updatedAt
        ? `${t.analysis.shared.dateTime.latest} ${updatedAt.replaceAll(
            "-",
            "/"
          )} (${map[frequency]})`
        : ""}
    </p>
  );
};
